<template>
    <v-form
        ref="formHistoricDialog"
        v-model="form.valid"
        lazy-validation
        class="d-inline-block"
    >
        <v-dialog
            v-model="drawerState"
            :value="drawerState"
            persistent
            max-width="740px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="!isEdit"
                    :loading="loading"
                    :disabled="loading"
                    :dark="!loading"
                    class="mr-1"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                    {{ $t('common.add') }}
                </v-btn>
            </template>
            <v-card v-if="drawerState">
                <v-card-title>
                    <span class="headline">{{ $t('corporate.constitutiveActs.form.header') }}</span>
                </v-card-title>
                <v-card-text class="pb-1">
                    <v-row>
                        <v-col cols="12" sm="6" class="pt-1 pb-1">
                            <input-date-picker :setup.sync="form.datePickers.date"></input-date-picker>
                        </v-col>
                        <v-col cols="12" sm="6" class="pt-1 pb-1">
                            <v-text-field
                                v-model="corporateHistoric.time"
                                :label="form.labels.time"
                                :rules="form.rules.time"
                                filled
                                dense
                                type="time"
                                min="00:00"
                                max="23:59"
                                required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pt-1 pb-1">
                            <v-text-field
                                v-model="corporateHistoric.title"
                                :label="form.labels.title"
                                :rules="form.rules.title"
                                required
                                filled
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pt-1 pb-4">
                            <div class="black--text"><strong>{{ form.labels.description }}</strong></div>
                            <v-row v-if="filePreview" class="d-flex justify-start">
                                <v-col>
                                    <contract-file-info :file="corporateHistoric.file" :type="'observation'" :clearFile="clearFile"/>
                                </v-col>
                            </v-row>
                            <div v-else class="mb-5 text-center">
                                <span style="color: red">{{ $t('corporate.constitutiveActs.form.filePreviewEmpty') }}</span>
                            </div>
                            <editor-observation v-model="resume" :color="'#E0E0E0'" :background="true" :files="addFile" :multipleFiles="false"/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-1 pl-6 pr-6">
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click="close()">{{ $t('common.close') }}</v-btn>
                    <v-btn color="primary" @click.native="save()">{{ $t('common.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import API from '@/api'
import InputDatePicker from '@/components/InputDatePicker'
import ContractFileInfo from '@/components/contract/ContractFileInfo'
import EditorObservation from '@/components/EditorObservation'

export default {
    name: 'modal-corporate-historic',
    components: {
        InputDatePicker,
        ContractFileInfo,
        EditorObservation
    },
    props: ['drawer', 'loading', 'isEdit', 'corporateHistoricDetail'],
    data () {
        return {
            drawerState: null,
            filePreview: false,
            changeFile: undefined,
            resume: null,
            form: {
                loading: true,
                valid: false,
                labels: {
                    title: this.$t('corporate.constitutiveActs.form.title.label'),
                    description: this.$t('corporate.constitutiveActs.form.description.label'),
                    time: this.$t('corporate.constitutiveActs.form.time.label')
                },
                datePickers: {
                    date: {
                        label: this.$t('corporate.constitutiveActs.form.date.label'),
                        rule: [
                            v => !!v || this.$t('corporate.constitutiveActs.form.date.required')
                        ],
                        required: true,
                        readonly: false,
                        filled: true,
                        dateFormatted: undefined
                    }
                },
                rules: {
                    title: [
                        v => !!v || this.$t('corporate.constitutiveActs.form.title.required'),
                        v => (v && v.length >= 3) || this.$t('corporate.constitutiveActs.form.title.length')
                    ],
                    time: [
                        v => !!v || this.$t('corporate.constitutiveActs.form.time.required')
                    ]
                }
            },
            basecorporateHistoric: undefined,
            corporateHistoric: {
                objectId: undefined,
                title: undefined,
                file: undefined,
                resume: '',
                date: undefined,
                clientId: undefined
            }
        }
    },
    watch: {
        drawer: function (val, oldVal) {
            this.drawerState = val
        },
        drawerState: function (val, oldVal) {
            this.init()
            this.$emit('update:drawer', val)
        }
    },
    methods: {
        init () {
            this.$refs.formHistoricDialog.reset()
            if (this.corporateHistoricDetail !== undefined) {
                this.basecorporateHistoric = JSON.parse(JSON.stringify(this.corporateHistoric))
                this.form.datePickers.date.dateFormatted = this.$options.filters.momentFormatDate(this.corporateHistoricDetail.date, 'L')
                this.corporateHistoric = JSON.parse(JSON.stringify(this.corporateHistoricDetail))
                this.filePreview = !!(this.corporateHistoric.file)
                this.resume = this.corporateHistoric.resume
            }
        },
        async addFile (event) {
            for (let i = 0; event.target.files.length > i; i++) {
                const file = event.target.files[i]
                const tempFile = file.slice(0, file.size)
                const newFile = new File([tempFile], file.name.replace(/[^a-zA-Z._0-9]/g, ''))
                this.changeFile = true
                this.filePreview = true
                this.corporateHistoric.file = newFile
            }
        },
        clearFile () {
            this.changeFile = true
            this.filePreview = false
            this.corporateHistoric.file = undefined
        },
        formatObject () {
            this.corporateHistoric.date = this.$helpers.formatDatetoParse(this.form.datePickers.date.dateFormatted)
            this.corporateHistoric.resume = this.resume
            return this.corporateHistoric
        },
        validateForm () {
            const errors = []
            if (!this.corporateHistoric.file) {
                errors.push(this.$t('corporate.constitutiveActs.form.needFile'))
            }

            if (this.resume.length <= 0) {
                errors.push(this.$t('corporate.constitutiveActs.form.needResume'))
            }

            return errors
        },
        async save () {
            const errors = this.validateForm()
            if (errors.length > 0) {
                alert(errors.join('\n'))
                return
            }

            this.corporateHistoric.clientId = this.$helpers.getCorporateClientId(this.$route.name, `${this.$route.meta.singleName}SocietarioAtoConstitutivo`, this.$route.params.id)
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            this.corporateHistoric.profile = currentUserCompany.objectId

            if (this.changeFile) {
                if (this.corporateHistoric.file !== undefined) {
                    this.corporateHistoric.file = await this.uploadFile(this.corporateHistoric.file)
                } else {
                    this.corporateHistoric.file = { __op: 'Delete' }
                }
            }
            let endpoint = API.EndPoints.saveAct
            new API(endpoint, this.formatObject()).request()
                .then((response) => {
                    this.close()
                    this.$emit('close-corporate-historic-success-dialog')
                }, (error) => {
                    if (error.status !== 0) this.saveError()
                })
        },
        async uploadFile (file) {
            let endpoint = API.EndPoints.upload
            endpoint.filename = this.$helpers.normalizeFilename(file.name)
            let fileFormated = await new API(endpoint, file).request()
                .then(response => {
                    let file = response.data
                    file.__type = 'File'
                    return file
                })
            return fileFormated
        },
        close () {
            this.resume = null
            this.clearFile()
            this.drawerState = false
        },
        saveError () {
            alert(this.$t('common.error'))
        }
    }
}
</script>
